export default __webpack_public_path__ + "static/media/group4.9ef84c19.png";